exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-wrap[data-v-0a51c249]{position:relative;width:265px;height:265px}.image-wrap img[data-v-0a51c249]{display:block;width:100%}@media screen and (max-width:900px){.image-wrap[data-v-0a51c249]{width:100%;height:140px;overflow:hidden}.image-wrap img[data-v-0a51c249]{position:relative;top:50%;left:50%;transform:translate(-50%,-50%)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a51c249","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/SlideNewsImage.vue
// module id = 289
// module chunks = 0